import { BACKSTAGE_COLUMN_ID } from "../constants";
import BackstageIntegrationTableDescriptionCell from "./DescriptionCell";
import BackstageIntegrationTableRowActionsCell from "./RowActionsCell";
import BackstageIntegrationTableNameCell from "./NameCell";
import IntegrationsRowSpaceCell from "./SpaceCell";

export const BACKSTAGE_TABLE_CELLS = {
  [BACKSTAGE_COLUMN_ID.NAME]: BackstageIntegrationTableNameCell,
  [BACKSTAGE_COLUMN_ID.DESCRIPTION]: BackstageIntegrationTableDescriptionCell,
  [BACKSTAGE_COLUMN_ID.SPACE]: IntegrationsRowSpaceCell,
  [BACKSTAGE_COLUMN_ID.DROPDOWN]: BackstageIntegrationTableRowActionsCell,
};
